var map = {
	"./en/2-1/title_2-1.png": 13590,
	"./fi/2-1/title_2-1.png": 19552,
	"./in/2-1/title_2-1.png": 31186,
	"./th/2-1/title_2-1.png": 79079,
	"./tw/2-1/title_2-1.png": 40916,
	"./zh/2-1/title_2-1.png": 70353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82520;